module.exports = __webpack_public_path__ + "fonts/Pretendard-Light.7d1a33b.woff";